<template>
  <div class="animated fadeIn">
    <template v-if="base">
    <List v-show="list" ref="list" />
    </template>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>